import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
export const WhatsAppButton = () => {
  return <a href="https://wa.link/paquete-navidad" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110 flex items-center justify-center group" aria-label="Contact us on WhatsApp" data-id="element-277">
      <Icon name="message-circle" size={28} className="relative z-10" data-id="element-278" />

      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-279">
        <div className="bg-gray-900 text-white text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap shadow-lg" data-id="element-280">
          ¿Tienes preguntas? Chatea con nosotros
          <div className="absolute top-full right-4 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-gray-900" data-id="element-281" />
        </div>
      </div>
    </a>;
};